import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { v4 as uuidv4 } from 'uuid';

import {TabulatorFull as Tabulator} from "tabulator-tables"; //import Tabulator library
//import '../Bs4Theme/tabulator_scss/themes/tabulator_simple.scss';

import Bs4MainDispatch from '../Bs4MainDispatch';
import Bs4Kartoteka from '../Bs4Kartoteka';
import Bs4ReportTabulator from './Bs4ReportTabulator';
import { TYPE_BS4REPORTTABULATOR } from '../Bs4Theme/Bs4UxTemplateEditors/Bs4ReportTabulatorUx';
import Bs4Criteria from './Bs4Criteria'
import Bs4CriteriaSummary from './Bs4CriteriaSummary'
import Bs4DataProvider from './Bs4DataProvider';
import * as Bs4Columns from './Bs4Columns';
import { useStateUxTemplate, SmallScreenContext } from '../Bs4Theme/Bs4UxTemplates';
import {isNullOrNaN} from '../Bs4Components/Bs4Utils';

export default class Bs4ReportType41 extends Bs4ReportTabulator {
  static SELECTION_MODEL_TYPE_SINGLE = 'single';
  static SELECTION_MODEL_TYPE_MULTIPLE = 'multiple';

  createModel() {
    super.createModel();    
    this.bs4DataProvider = new Bs4DataProvider(this.props, null, 'treestorebs4data');
    this.bs4DataProvider.resetBs4PageProps(); 
  }

  getColumns (colDef) {
    let columns = [{
      title:"Name", 
      field: "text", 
      resizable: true, 
      headerSort:false, 
      formatter: 'html'
    }];

    if (this.selectableCheckbox) {
      //!! resizable: false - inaczej błąd
      const selectColumnOld = {
        formatter:"rowSelection", 
        titleFormatter:"rowSelection", 
        hozAlign:"center", 
        headerSort:false, 
        frozen:true, 
        resizable: false,
        //resizable: true,
        widthGrow: -1,
        widthShrink: -1,
      };
      const selectColumn = {
        formatter: "rowSelection", 
        titleFormatter: "rowSelection", 
        hozAlign: "center", 
        headerSort: false, 
        frozen: true, 
        resizable: false,
        widthGrow: -1,
        widthShrink: -1,
        titleFormatterParams:{
          rowRange:"active" //only toggle the values of the active filtered rows
        }
      }; 
      columns = [selectColumn, ...columns];
    }

    if (this.getPageParam('allowdragdrop')) {
      const movableColumn = {
        rowHandle: true,
        //formatter:"handle", 
        formatter: Bs4Columns.formatterHandle, 
        //titleFormatter:"rowSelection", 
        //hozAlign:"center", 
        headerSort:false, 
        frozen:true, 
        resizable: false,
        widthGrow: -1,
        widthShrink: -1,
      }; 
      columns = [movableColumn, ...columns];
    }    
    
    return columns;
  }

  getTreeData(data, level) {
    if (isNullOrNaN(level)) level  = 0;
    if (!Array.isArray(data)) return null;
    data = data.map(record => {
      record.id = record.id || uuidv4();
      // record.expanded = false;
      record.children = this.getTreeData(record.children, level + 1);
      if (!record.children) delete record.children;      
      return record;
    })
    if (Array.isArray(data) && data.length === 0) data = null;
    return data;
  }
  
  startRowMovingData = null;

  rowMoving(row) {
    this.startRowMovingData = this.tabulator.getData();
  }

  rowMoved(_row) {
    console.log('...Moved...', _row)
    if (!_row) return;
    console.log('...Moved...Ok')

    const getRow = (id, data, remove) => {
      if (!Array.isArray(data)) return null;
      for(let i = 0; i < data.length; i++){    
        let row = data[i];
        if (row.id === id) { 
          if (remove) data.splice(i, 1); 
          return row;
        }
        row = getRow(id, row.children, remove);
        if (row) return row;
      }
      return null;
    }

    const getParet = (id, data, parent) => {
      if (!Array.isArray(data)) return null;
      for(let i = 0; i < data.length; i++){    
        let row = data[i];
        if (row.id === id) { 
          return parent;
        }
        const pt = getParet(id, row.children, row);
        if (pt) return pt;
      }
      return null;
    }

    const insertRowBefore = (rowBefore, rowAfter, data) => {
      if (!Array.isArray(data)) return null;
      if (!rowAfter) return null;      
      for(let i = 0; i < data.length; i++){    
        let row = data[i];
        if (row.id === rowAfter.id) {
          data.splice(i, 0, rowBefore); 
          return row;
        }
        row = insertRowBefore(rowBefore, rowAfter, row.children)
        if (row) return row;
      }
      return null;
    }

    const data = this.tabulator.getData();
    
    if (this.rowMouseOver) {      
      const parent = getRow(this.rowMouseOver, data);
      let parebntOfParent = parent;
      while (parebntOfParent !== null) {        
        //Czy parent zapętlony?
        if (parebntOfParent?.id === _row._row.data.id) {
          this.tabulator.setData(this.getTreeData(this.startRowMovingData) || []);
          return;
        }
        parebntOfParent = getParet(parebntOfParent.id, data, null);
      }
      if (!Array.isArray(parent.children)) parent.children = []
      parent.children.push(getRow(_row._row.data.id, data, true));
    } else {
      const row = getRow(_row._row.data.id, data, true);
      const rowAfter = this.tabulator.getRowFromPosition(_row?._row?.position + 1)?._row?.data;
      if (!insertRowBefore(row, rowAfter, data)) {
        data.push(row);
      }
    }      
    this.tabulator.setData(this.getTreeData(data) || []);

    this.updateMove()
  }

  // reload = () => {    
  //   const rowIndex = this.getTopRow();
  //   const currentPabeNumber = this.tabulator.getPage();
  //   this.tabulator.setData()
  //   .then(() => {this.tabulator.scrollToRow(rowIndex)})
  //   .catch(error => {console.log(error)});
  // }

  reload = () => {
    this.bs4DataProvider.resetBs4PageProps();
    this.bs4DataProvider.fetchMore()
  }

  fetchStoreData (data, parent, storeData) {
    if (!storeData) storeData = []
    data.forEach(row => {
      storeData.push(`${row.id},${parent}`);
      if (Array.isArray(row.children)) this.fetchStoreData(row.children, row.id, storeData);
    })
    return storeData;
  }

  updateMove() {
		const details = {
			selectedRows: this.tabulator.getSelectedData().map(row => row.id),
			storeData: this.fetchStoreData(this.tabulator.getData(), 'root'), 
      currFormId: this.formId,
		};
		 
    console.log('=tree 41 = save ', details);
    //1199 Uporządkowanie przeciągania w drzewkach [Core]
		//Bs4MainDispatch.commandParser('Bs4ReportOption', details, this.bs4KartotekaId);
    Bs4MainDispatch.commandParser('bs4DragDrop', details, this.bs4KartotekaId);
  }

  rowMouseOver = null;
  rowMouseEnter(e, row) {this.rowMouseOver = row?._row?.data.id;}
  rowMouseLeave(e, row) {this.rowMouseOver = null;}

  tabulator = null;

  selectionType = null;
  selesctedRowsId = new Set();
  selectionEvent = true;

  selectRow(rowsId) {
    this.selectionEvent = false;
    this.tabulator.selectRow(rowsId);
    this.selectionEvent = true;
  }
  
  deselectRow(rowsId) {
    this.selectionEvent = false;
    this.tabulator.deselectRow(rowsId);
    this.selectionEvent = true;
  }

  clearSelected() {
    this.selectionEvent = false;
    this.selesctedRowsId.clear();
    this.tabulator.deselectRow(this.tabulator.getSelectedData().map(row => row.id));
    this.selectionEvent = true;
  }

  rowSelected(row) {    
    if (this.selectionType === Bs4ReportType41.SELECTION_MODEL_TYPE_SINGLE) {      
      this.clearSelected();
      this.selesctedRowsId.add(row._row.data.id);
      this.selectRow(row._row.data.id);
    } else {
      this.selesctedRowsId.add(row._row.data.id);
    }    
    //this.rowSelectionChanged();
  }

  rowDeselected(row) {
    this.selesctedRowsId.delete(row._row.data.id);
    //this.rowSelectionChanged();
  }

  rowClick(e, row) {    
    this.rowActiveClick = Boolean(this.rowActiveClick)
    console.log('...row_active_click...', this.rowActiveClick, Boolean(this.rowActiveClick));
    if (this.cellEditing) return;
    let clickSuccessful = false;
    if (Bs4MainDispatch.commandParserAfter(this.bs4KartotekaId)) {
      clickSuccessful = true;
    } else {
      if (this.rowActiveClick === '1') {
        Bs4MainDispatch.commandParser('Bs4RowClick',{ rowObjectId: row.getData().id, currFormId: this.formId }, this.bs4KartotekaId);
        clickSuccessful = true;
      }
      if (this.rowActiveClick === '2' && !this.targetField?.handleActionsFooterOk) {
        Bs4MainDispatch.commandParser('Bs4RowClick',{ rowObjectId: row.getData().id, currFormId: this.formId }, this.bs4KartotekaId);
        clickSuccessful = true;
      }
    }
    
    if (clickSuccessful) {
      const id = row.getData().id;
      Bs4MainDispatch.lastCommandParserAfterRow = {
        id: id,
        row: row,
        select: () => {
          this.lastCommandParserAfterRow = id;
          try {
            this.tabulator?.getRow(id)?.update({});
          } catch(error) {
            console.log('...lastCommandParserAfterRow.select.Error:', error)
          }
        },
        deSelect: () => {
          delete this.lastCommandParserAfterRow;
          try {
            this.tabulator?.getRow(id)?.update({});
          } catch(error) {
            console.log('...lastCommandParserAfterRow.deSelect.Error:', error)
          }
          this.reload();
        },
      };
    }

		// if(this.getPageParam('row_active_click')) {		 
    //   Bs4MainDispatch.commandParser('Bs4RowClick',{ rowObjectId: row.getData().id, currFormId: this.formId}, this.bs4KartotekaId);
		// }			
  }

  runListOption(item) { 
		const details = { 
			reportOptionId: item?.bs4Id, 
			selectedRows: this.tabulator.getSelectedData().map(row => row.id),
			storeData: this.fetchStoreData(this.tabulator.getData(), 'root'),
      currFormId: this.formId,
		}

		Bs4MainDispatch.commandParser('Bs4ReportOption', details, this.bs4KartotekaId);
    this.atrybProgressbar(item);
	}

  ViewComponent = React.forwardRef((props, ref) => {
    const report = this;
    const theme = useTheme()
    const refTabulator = React.useRef();
    const {dateTimeStamp} = useStateUxTemplate(TYPE_BS4REPORTTABULATOR);
    const smallScreen = React.useContext(SmallScreenContext);
    const boxSx = React.useMemo(() => this.getBoxSxTabulator(theme, smallScreen), [dateTimeStamp, theme, smallScreen]);


    const boxSx3 = React.useMemo(() => {
      return {
        '.tabulator': {          
          '.tabulator-row': {                        
            '.tabulator-data-tree-branch': {
              borderColor: '#ff00ff',
            },
          },            
        }
      };
    }, []);

    React.useEffect(() => {  
      const setNewData = (data) => {
        const dataTree = this.getTreeData(data);        
        this.tabulator.setData(dataTree);
      }
      this.bs4DataProvider.on(Bs4DataProvider.DATA_LOADED, setNewData);
      this.bs4DataProvider.fetchMore();

      return (() => {
        this.bs4DataProvider.off(setNewData);
      });
    }, [])
    
    React.useEffect(() => {   
      if (this.tabulator && this.tableBuilt) this.tabulator.redraw();
    }, []);
    
    React.useEffect(() => {          
      const timing = getComputedStyle(document.documentElement).getPropertyValue('--logo-speedTiming').replace('s', '');
      this.selectableCheckbox = this.getSelectableCheckbox();

      this.tabulator = new Tabulator(refTabulator.current, {
        headerVisible: false,
        dataTree: true,
        rowFormatter: this.rowFormatter,
        // dataTreeStartExpanded: true,
        dataTreeStartExpanded: function(row, level){
          return row.getData().expanded; //expand rows where the "driver" data field is true;
        },
        selectable: "highlight",
        movableRows: this.getPageParam('allowdragdrop'),
        dataTreeChildField: "children",
        dataTreeElementColumn: "text",
        columns: this.getColumns(),
        data: [],
        
        layout: "fitDataFill",        
      });

      this.tabulator.on("rowSelected", function(row){
        if (report.selectionEvent) report.rowSelected(row);
      });

      this.tabulator.on("rowDeselected", function(row){
        if (report.selectionEvent) report.rowDeselected(row);
      });

      this.tabulator.on("dataProcessed", function() {
        report.selectRow(Array.from(report.selesctedRowsId));
      });

      this.tabulator.on("rowClick", function(e, row){
        report.rowClick(e, row)
      });      

      this.tabulator.on("rowMoving", function(row){
        report.rowMoving(row);
      });

      this.tabulator.on("rowMoved", function(row){
        report.rowMoved(row);
      });

      this.tabulator.on("rowMouseEnter", function(e, row){
        report.rowMouseEnter(e, row);
      });

      this.tabulator.on("rowMouseLeave", function(e, row){
        report.rowMouseLeave(e, row);
      });    

      this.tabulator.on("tableBuilt", () => {
        this.tableBuilt = true;        
        // this.autoGridReloadEvery();
        this.triggerTabulatorBuilt(true);
      });

    }, [])
    
    return (
      <Box ref={ref} height='100%' width='100%' display='flex' flexDirection='column' overflow='hidden' px={props.uxKartoteka?.spacing}>
        <Box display="flex" flexDirection='row' flexWrap='wrap' gap='6px' p={0.5} alignItems='center'>
          <Bs4Criteria {...report.props}/>
          <report.ReportBs4HorizontalMenu/>
        </Box>
        <Box pt={props.uxKartoteka?.spacing / 3}/>
        <Bs4CriteriaSummary {...report.props}/>        
        <Box overflow='hidden' sx={{...boxSx, flex: 1,}}>
          <div ref={refTabulator} style={{height: '100%',}}/>        
        </Box>
        <report.bs4DataProvider.ViewPagination/>
      </Box>
    );
  });
}
